export default __webpack_public_path__ + "static/media/rago.b10de004.jpg";